import { useRoomContext } from '@/RoomContext'
import { useUserContext } from '@/UserContext'
import { useEffect } from 'react'

export function useRoomStatePreload() {
    const [userState] = useUserContext()
    const [_roomState, roomDispatch] = useRoomContext()
    useEffect(() => {
        if (userState?.profile?.policy?.roomTierPolicy) {
            roomDispatch({
                type: 'update_room_context',
                value: { roomTierPolicy: userState.profile.policy.roomTierPolicy },
            })
        }
    }, [])
}
